/**
 * Load More Products Logic for Dawn
 */
document.addEventListener('click', function (event) {
  const loadMoreBtn = event.target.closest('#load-more-button');
  if (!loadMoreBtn) return;

  event.preventDefault();

  const spinner =
    loadMoreBtn.closest('.load-more, .load-more-container')?.querySelector('.loading__spinner') ||
    document.querySelector('.load-more-container .loading__spinner');
  const loadMoreContainer = loadMoreBtn.closest('[data-search-results]');
  const activePanel = document.querySelector('.template-search__tab-panel--active');
  const productGrid =
    activePanel?.querySelector('.grid') ||
    document.querySelector('#product-grid.grid') ||
    document.querySelector('#product-grid .grid') ||
    document.getElementById('product-grid');
  const isSearchTabLoadMore = Boolean(activePanel && loadMoreContainer);

  function getCurrentCount(grid) {
    return grid ? grid.querySelectorAll('.grid__item:not(.grid__item--inline-banner)').length : 0;
  }

  function updateSearchCountDisplay(count) {
    const searchCountDisplay = document.getElementById('js-results-shown');
    if (searchCountDisplay) {
      searchCountDisplay.textContent = count;
    }
  }

  function updateCollectionCountDisplay(count) {
    const collectionCountDisplay = document.getElementById('js-products-shown');
    if (collectionCountDisplay) {
      collectionCountDisplay.textContent = count;
    }
  }

  let requestUrl = loadMoreBtn.getAttribute('data-url');
  const activePanelId = activePanel?.id;

  if (isSearchTabLoadMore) {
    const tabKey = activePanelId === 'page-results' ? 'pages' : 'products';
    const tabNextUrl = tabKey === 'pages' ? loadMoreContainer.dataset.nextUrlPages : loadMoreContainer.dataset.nextUrlProducts;
    if (tabNextUrl) {
      requestUrl = tabNextUrl;
    }
  }

  if (!requestUrl) {
    loadMoreBtn.classList.add('hidden');
    return;
  }

  if (spinner) spinner.classList.remove('hidden');
  loadMoreBtn.classList.add('hidden');

  const fetchSearchPageWithItems = (url, tries = 0) => {
    return fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selector = activePanelId ? `#${activePanelId} .grid__item` : '#product-grid .grid__item';
        const newProducts = html.querySelectorAll(selector);
        const newNextUrl = html.querySelector('#load-more-button')?.getAttribute('data-url') || '';

        if (newProducts.length === 0 && newNextUrl && tries < 8) {
          return fetchSearchPageWithItems(newNextUrl, tries + 1);
        }

        return { newProducts, newNextUrl };
      });
  };

  const requestPromise = isSearchTabLoadMore
    ? fetchSearchPageWithItems(requestUrl)
    : fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const newProducts = html.querySelectorAll('#product-grid .grid__item');
          const newNextUrl = html.querySelector('#load-more-button')?.getAttribute('data-url') || '';
          return { newProducts, newNextUrl };
        });

  requestPromise
    .then(({ newProducts, newNextUrl }) => {
      newProducts.forEach((product) => {
        productGrid?.appendChild(product);
      });

      const currentProductCount = getCurrentCount(productGrid);

      if (isSearchTabLoadMore) {
        const tabKey = activePanelId === 'page-results' ? 'pages' : 'products';
        const totalCount = Number(
          tabKey === 'pages'
            ? loadMoreContainer.dataset.resultsTotalPages || '0'
            : loadMoreContainer.dataset.resultsTotalProducts || '0'
        );

        if (newNextUrl) {
          loadMoreBtn.setAttribute('data-url', newNextUrl);
          if (tabKey === 'pages') {
            loadMoreContainer.dataset.nextUrlPages = newNextUrl;
          } else {
            loadMoreContainer.dataset.nextUrlProducts = newNextUrl;
          }
        }

        updateSearchCountDisplay(currentProductCount);
        loadMoreBtn.classList.toggle('hidden', currentProductCount >= totalCount);
      } else {
        updateCollectionCountDisplay(currentProductCount);

        if (newNextUrl) {
          loadMoreBtn.setAttribute('data-url', newNextUrl);
          loadMoreBtn.classList.remove('hidden');
        } else {
          loadMoreBtn.remove();
        }
      }

      if (isSearchTabLoadMore) {
        document.dispatchEvent(new CustomEvent('search:load-more-updated'));
      }
    })
    .catch((e) => {
      console.error('Error loading more products:', e);
    })
    .finally(() => {
      if (spinner) spinner.classList.add('hidden');
    });
});
